export { default } from './Tab';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Tab/index.js
// module id = 270
// module chunks = 2